import { Component, OnInit, Input, EventEmitter, Output, OnChanges } from '@angular/core';

@Component({
  selector: 'app-consulta-parecer-tecnico',
  templateUrl: './consulta-parecer-tecnico.component.html',
  styleUrls: ['./consulta-parecer-tecnico.component.scss']
})
export class ConsultaParecerTecnicoComponent implements OnInit, OnChanges {


  @Input() consulta: any;
  @Input() titulo = "";
  @Input() idConsulta = "";
  @Input() tipoConsulta = "";
  @Input() codigoControle = "";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  descricaoStatusConsulta = "info";
  subTitulo: any;
  texto: any;
  nivelSinalizador;

  msg = "";

  @Input() token = '';

  constructor() { }

  ngOnInit() { }

  ngOnChanges() {
    this.msg = "";
    this.setStatusConsulta();
    this.setMensagem();
  }

  reciverReload(parecertecnico) {
    this.msg = "";
    this.consulta.parecertecnico = parecertecnico;
    this.setStatusConsulta();
    this.setMensagem();
  }

  retornaConsultaParecerOuIndicio() {
    if (this.consulta && this.consulta.parecertecnico != null
      && this.consulta.parecertecnico.parecerTecnico != null) {
      return this.consulta.parecertecnico;
    }
    if (this.consulta.indicio != null && this.consulta.indicio.parecerTecnico != null && this.consulta.indicio.parecerTecnico != "") {
      return this.consulta.indicio;
    }
  }


  escolheIdConsulta() {
    if (this.consulta != null && this.consulta.parecertecnico != null
      && this.consulta.parecertecnico.parecerTecnico != null) {

      return this.consulta.parecertecnico.id;

    }
    if (this.consulta.indicio != null && this.consulta.indicio.parecerTecnico != null && this.consulta.indicio.parecerTecnico != "") {
      return this.consulta.indicio.id;
    }

  }

  setStatusConsulta() {
    this.msg = "";
    if (this.consulta.parecertecnico != null) {
      switch (this.consulta.parecertecnico.codigoControle) {
        case "ERRO_FORNECEDOR":
          this.descricaoStatusConsulta = "danger";
          this.msg = "";
          break;

        case "PENDENTE":
        case "OK":
        case "SEMREGISTRO":
          this.descricaoStatusConsulta = "info";
          break;
        default:
          this.descricaoStatusConsulta = "info";
      };
    }

  }

  setMensagem() {
    if (this.consulta && this.consulta.parecerTecnico) {
      if (this.consulta.parecerTecnico == "1") {
        this.nivelSinalizador = 1;
        this.msg = "NADA CONSTA";
        // this.texto = "Nenhum registro de ocorrência junto a seguradoras foi encontrado.";
        this.texto = "Este dado é gerado estatisticamente e não representa a situação final junto a companhias de seguro, visto que os critérios para aceitação são internos e exclusivos de cada companhia e não são compartilhados. Recomenda-se usar apenas como informação de apoio juntamente com os demais itens de sinistralidade.";
        this.status = 'success';
      } if (this.consulta.parecerTecnico == "2") {
        this.nivelSinalizador = 5;
        this.msg = "RISCO MÉDIO";
        // this.texto = "Foram encontrados reparos ou restrições junto a seguradoras, podendo ser considerado em avaliações de seguros futuros (baixo score ou reprovação).";
        this.texto = "Indicador relativo a aceitação junto a seguradoras. Este dado é gerado estatisticamente e não representa a situação final junto a companhias de seguro, visto que os critérios para aceitação são internos e exclusivos de cada companhia e não são compartilhados. Recomenda-se usar apenas como informação de apoio juntamente com os demais itens de sinistralidade e complementar o perfil do veículo com o parecer de um vistoriador qualificado através de laudo cautelar e/ou avaliação estrutural do veículo.";
        this.status = 'warning';
      } if (this.consulta.parecerTecnico == "3") {
        this.nivelSinalizador = 9;
        this.msg = "RISCO ALTO";
        // this.texto = "Avarias mais graves, possível indenização integral, podendo levar a reprovação em seguros futuros.";
        this.texto = "Indicador relativo a aceitação junto a seguradoras. Este dado é gerado estatisticamente e não representa a situação final junto a companhias de seguro, visto que os critérios para aceitação são internos e exclusivos de cada companhia e não são compartilhados. Recomenda-se usar apenas como informação de apoio juntamente com os demais itens de sinistralidade e complementar o perfil do veículo com o parecer de um vistoriador qualificado através de laudo cautelar e/ou avaliação estrutural do veículo.";
        this.status = 'warning';
      }
    }
    if (this.consulta.indicio != null && this.consulta.indicio.parecerTecnico != null && this.consulta.indicio.parecerTecnico != "") {
      if (this.consulta.indicio.parecerTecnico == "1")
      this.nivelSinalizador = 1;
        this.msg = "NADA CONSTA";
      if (this.consulta.indicio.parecerTecnico == "2")
      this.nivelSinalizador = 5;
        this.msg = "RISCO MÉDIO";
      if (this.consulta.indicio.parecerTecnico == "3")
      this.nivelSinalizador = 9;
        this.msg = "RISCO ALTO";
    }
  }


}

